module.exports = __webpack_public_path__ + "img/fig9.28.e7b8eb27.png";